import { createContext, useContext } from 'react';

export type MobileSearchContextType = {
  isOpen: boolean;
  toggleDrawer: () => void;
  topSearches: { id: string; keyword: string; link: string }[];
  fetchTopSearches: () => Promise<void>;
};

export const MobileSearchContext = createContext<{
  isOpen: boolean;
  toggleDrawer: () => void;
} | null>(null);

export const useMobileSearch = () => {
  const context = useContext(MobileSearchContext);
  if (!context) {
    throw new Error('useMobileSearch must be used within a MobileSearchProvider');
  }
  return context;
};
